import React, { FC, useEffect, useState } from 'react';
import Layout from 'app/layouts/layout';
import Seo from 'app/components/Seo';
import SliderCarousel from 'app/components/SliderCarousel';
import SectionsListing from 'app/components/SectionsListing';
import HPBanner from 'app/components/HPBanner';
import RecentInsightsLists from 'app/components/RecentInsightsLists';
import usePageData from 'app/hooks/usePageData';
import useRecentlyLinks from 'app/hooks/useRecentlyLinks';
import LoginForm from 'app/components/Modal/LoginForm';
import { useHistory, useLocation } from 'react-router-dom';

export const HomePage: FC = () => {
  const { pageData } = usePageData('/');
  const location = useLocation(); // Hook for accessing query params
  const navigate = useHistory(); // Hook for navigation
  const { updateRecentlyLinks } = useRecentlyLinks();
  const [isLoginOpened, setIsLoginOpened] = useState(false);

  const openLoginModal = () => {
    setIsLoginOpened(true);
  };

  const closeLoginModal = () => {
    setIsLoginOpened(false);
  
    // Remove `sessionexpired` from localStorage
    localStorage.removeItem('sessionExpired');
  };
  
  useEffect(() => {
    // Scroll to the top when the component mounts
    window.scrollTo(0, 0);
    updateRecentlyLinks('Home', '');
  
    // Check `sessionexpired` in localStorage
    const sessionExpired = localStorage.getItem('sessionExpired');
    if (sessionExpired === 'true') {
      openLoginModal();
    }
  }, [updateRecentlyLinks]);
  

  return (
    <Layout>
      {pageData?.seo && (
        <Seo
          title={pageData.seo.meta_title}
          description={pageData.seo.meta_description}
          {...pageData?.seo}
        />
      )}
      <SliderCarousel />
      <SectionsListing />
      <HPBanner />
      <RecentInsightsLists />
      <LoginForm
        onCanelClick={closeLoginModal}
        isModalOpened={isLoginOpened}
        closeLoginModal={closeLoginModal}
      />
    </Layout>
  );
};
